var map = {
	"./auth-background.webp": 1912,
	"./close-btn.webp": 1913,
	"./icon-caution.webp": 1914,
	"./icon-checked.webp": 1915,
	"./icon-contact-us.webp": 1916,
	"./icon-email.webp": 1917,
	"./icon-eye-close.webp": 1918,
	"./icon-eye-open.webp": 1919,
	"./icon-forget-phone.webp": 1920,
	"./icon-forget-whatsapp.webp": 1921,
	"./icon-google.webp": 1922,
	"./icon-login-email-2.webp": 1923,
	"./icon-login-email.webp": 1924,
	"./icon-password.webp": 1925,
	"./icon-robot-select.webp": 1926,
	"./icon-robot-unselect.webp": 1927,
	"./icon-telegram.webp": 1928,
	"./icon-user.webp": 1929,
	"./jackpot-cn.webp": 1930,
	"./jackpot-mobile-cn.webp": 1931,
	"./jackpot-mobile-ms.webp": 1932,
	"./jackpot-mobile.webp": 1933,
	"./jackpot-ms.webp": 1934,
	"./jackpot.webp": 1935,
	"./login-bg.webp": 1936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;